//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const RbLoading = () =>
  import(/* webpackChunkName: "loader-chunk" */ '@/elements/loading/rb-loading.vue')
import RbFacebookLogin from '@/elements/facebook-login/facebook-login.vue'

import { mapActions, createNamespacedHelpers, mapGetters } from 'vuex'
import { required, requiredIf, sameAs, email } from 'vuelidate/lib/validators'
import {
  ACTION_LOG_IN,
  ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS,
} from '@/scripts/store/actions/pdp'

import { ACTION_LOAD_USER } from '@/scripts/store/actions'

const { mapActions: mapActionsPdp, mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
import wcs from '@/scripts/libs/wcs'
const isDobFieldValid = (value, vm) => vm.isDobAboveCutoffAge

import { WcsLogin } from '@/scripts/libs/wcs/login'
export default {
  name: 'rb-pdp-register',
  components: {
    RbLoading,
    RbFacebookLogin,
  },
  props: {
    isFrameAdvisor: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      errorAgeContent: false,
      lastStepContent: false,
      firstName: '',
      lastName: '',
      emailAddress: '',
      dayOfBirth: '',
      monthOfBirth: '',
      yearOfBirth: '',
      password: '',
      passwordRepeat: '',
      emailSignUp: '',
      agreeConsent: '',
      profilingConsent: '',
      country: '',
      submitted: false,
      response: false,
      error: false,
      errorMessage: false,
      countriesWithoutDob: ['AU', 'BR', 'CA', 'MX', 'NO', 'KR', 'HK', 'CN'],
      cutoffAge: 18,
      cutoffAgeFacebook: 16,
      asianCountries: ['HK', 'CN'],
      countriesWithoutProfilingConsent: ['AU', 'BR', 'CA', 'MX', 'USA', 'NO', 'HK', 'CN'],
      facebookRegistrarion: false,
      dataFb: {},
      socialLoginEnabled: false,
    }
  },
  validations() {
    return {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      emailAddress: {
        required,
        email,
      },
      monthOfBirth: {
        required: requiredIf(function () {
          return this.isDobEnabled
        }),
        isDobFieldValid,
      },
      dayOfBirth: {
        required: requiredIf(function () {
          return this.isDobEnabled
        }),
        isDobFieldValid,
      },
      yearOfBirth: {
        required: requiredIf(function () {
          return this.isDobEnabled
        }),
        isDobFieldValid,
      },
      password: {
        required,
      },
      passwordRepeat: {
        required,
        sameAsPassword: sameAs('password'),
      },
      emailSignUp: this.emailSignUpValidationRule,
      agreeConsent: this.agreeConsetValidationRule,
      profilingConsent: this.profilingConsentValidationRule,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    ...mapGettersPdp(['ui']),
    isDobEnabled() {
      if (this.facebookRegistrarion === true) return true
      return this.country ? !this.countriesWithoutDob.includes(this.country) : false
    },
    isFacebookRegistration() {
      return this.facebookRegistrarion
    },
    isDobAboveCutoffAge() {
      if (this.facebookRegistrarion === true) return true
      const age = this.calculateAgeUsingDate(this.monthOfBirth, this.dayOfBirth, this.yearOfBirth)
      return age < this.cutoffAge ? false : true
    },
    isDobAboveCutoffAgeFacebook() {
      const age = this.calculateAgeUsingDate(this.monthOfBirth, this.dayOfBirth, this.yearOfBirth)
      return age < this.cutoffAgeFacebook ? false : true
    },
    isEmailSignUpEnabled() {
      return this.country !== 'USA'
    },
    isAgreeConsentEnabled() {
      return true
    },
    isProfilingConsentEnabled() {
      return true
    },
    emailSignUpValidationRule() {
      const emailSignupValidator = {
        sameAs: sameAs(() => 'true'),
        required: requiredIf(function () {
          return this.isEmailSignUpEnabled
        }),
      }
      return this.isEmailSignUpEnabled ? emailSignupValidator : {}
    },
    agreeConsetValidationRule() {
      return {}
    },
    profilingConsentValidationRule() {
      const profilingConsentValidator = {
        sameAs: sameAs(() => 'true'),
        required: requiredIf(function () {
          return this.isProfilingConsentEnabled
        }),
      }
      return this.isProfilingConsentEnabled ? profilingConsentValidator : {}
    },
    isFacebookShow() {
      if (this.errorAgeContent || this.lastStepContent) {
        return false
      }
      return true
    },
    isSocialLoginEnabled() {
      return this.socialLoginEnabled
    },
  },
  mounted() {
    const country = document.getElementById('country')
    this.country = country && country.value ? country.value : 'US'

    const cutoffAgeEl = document.getElementById('cutoffAge')
    this.cutoffAge = cutoffAgeEl && cutoffAgeEl.value ? cutoffAgeEl.value : 18
    const privacyPolicyLinkEl = document.querySelector('.rb-fieldrow-checkbox__desc a')
    if (privacyPolicyLinkEl) {
      privacyPolicyLinkEl.setAttribute('data-analytics_available_call', '0')
    }

    const { facebookLogin } = wcs.getStoreConfig()
    this.socialLoginEnabled = facebookLogin
  },
  methods: {
    updateFieldsFromFbRegister(dataFb) {
      this.errorAgeContent = false
      this.lastStepContent = false

      if (dataFb.userData.isLogged) {
        this.dataFb = dataFb

        this.facebookRegistrarion = true

        this.firstName = this.dataFb.userData.firstName
        this.lastName = this.dataFb.userData.lastName
        this.emailAddress =
          this.dataFb.userData.email === undefined ? '' : this.dataFb.userData.email
        if (this.isDobEnabled) {
          this.dayOfBirth = this.dataFb.userData.dayOfBirth
          this.monthOfBirth = this.dataFb.userData.monthOfBirth
          this.yearOfBirth = this.dataFb.userData.yearOfBirth

          if (!!this.dayOfBirth || !!this.monthOfBirth || !!this.yearOfBirth) {
            if (!this.isDobAboveCutoffAgeFacebook) {
              this.errorAgeContent = true
            }
          }
        }
        if (!this.errorAgeContent) {
          this.lastStepContent = true
        }
      } else {
        this.facebookRegistrarion = false
      }
    },
    ...mapActions({
      loadUserData: ACTION_LOAD_USER,
    }),
    ...mapActionsPdp({
      logIn: ACTION_LOG_IN,
      changePrivateSalesFormsStatus: ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS,
    }),
    showLoginForm() {
      this.$emit('showLoginForm')
    },
    handleClose() {
      this.password = ''
      this.emailAddress = ''
      this.submitted = false
      this.response = false
      this.$emit('close')
    },
    calculateAgeUsingDate(birthMonth, birthDay, birthYear) {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const day = today.getDate()
      let age = year - birthYear

      if (month < birthMonth - 1) {
        age--
      }
      if (birthMonth - 1 == month && day < birthDay) {
        age--
      }
      return age
    },
    getEmailSignupDescription() {
      if (this.asianCountries.includes(this.country)) {
        const isGDPREnabledEl = document.getElementsByName('isGDPREnabled')[0]
        if (isGDPREnabledEl && isGDPREnabledEl.value && isGDPREnabledEl.value === 'true') {
          const lastPartSignupDescr =
            this.country === 'HK' ? 'beforeSignupLogonForm' : 'dotLogonForm'
          return `${this.translation(
            'private_sale.emailSignup.subscribeEmailLogonForm'
          )} ${this.translation(
            'private_sale.emailSignup.privacyPolicyLogonForm'
          )} ${this.translation('private_sale.emailSignup.' + lastPartSignupDescr)}`
        } else {
          return `${this.translation(
            'private_sale.emailSignup.loginSignupLogonForm1TheOnes'
          )} ${this.translation(
            'private_sale.emailSignup.privacyPolicyLogonForm'
          )} ${this.translation('private_sale.emailSignup.loginSignupLogonForm2TheOnes')}`
        }
      } else {
        return this.translation('private_sale.emailSignup.agreeThatMyInfoCanBeUsedToSendNewsOffers')
      }
    },
    getAgreeConsentDescription() {
      return `<span class="title_field"> ${this.translation(
        'private_sale.emailDetailSignUp'
      )}</span>
       ${this.translation('private_sale.registrationOnesConsent')}`
    },

    getProfilingConsent() {
      return `<span class="title_field">${this.translation(
        'private_sale.profilingTitle'
      )}</span> ${this.translation('private_sale.profilingConsent')}`
    },
    submitCheckAllow() {
      if (this.isFacebookRegistration) {
        if (
          !this.$v.firstName.$error &&
          !this.$v.lastName.$error &&
          !this.$v.emailAddress.$error &&
          !this.$v.dayOfBirth.$error &&
          !this.$v.monthOfBirth.$error &&
          !this.$v.yearOfBirth.$error &&
          !this.$v.emailSignUp.$error &&
          !this.$v.agreeConsent.$error &&
          !this.$v.profilingConsent.$error
        ) {
          if (!this.isDobAboveCutoffAgeFacebook) {
            this.lastStepContent = false
          } else {
            return true
          }
        }
      } else {
        if (!this.$v.$invalid) return true
      }
      return false
    },
    submit() {
      this.$v.$touch()
      if (this.submitCheckAllow() === true) {
        this.lastStepContent = true
        this.errorAgeContent = false

        this.submitted = true
        const date = new Date()
        let currentTime = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`
        let formData = {
          firstName: this.firstName,
          lastName: this.lastName,
          logonId: this.emailAddress,
          email1: this.emailAddress,
          logonPassword: this.password,
          logonPasswordVerify: this.passwordRepeat,
          currentTime: currentTime,
          emailSubscription: this.emailSignUp,
          privacyPolicy: this.agreeConsent,
          country: this.country,
        }
        if (this.isDobEnabled) {
          const dob = `${this.yearOfBirth}-${this.monthOfBirth}-${this.dayOfBirth}`
          formData['dob'] = dob
        }
        if (this.isFacebookRegistration === true) {
          formData['dataFb'] = this.dataFb
        }
        WcsLogin.submitRegisterForm(formData).then((response) => {
          if (response.error) {
            this.error = response.error
            this.errorMessage = response.errorMessage
            this.submitted = false

            this.$ma.trackEvent({
              event: 'Error',
              value: {
                Error_Source: 'Login - Facebook',
                Error_Message: 'response.errorMessage',
              },
            })
          } else {
            this.logIn()
            this.loadUserData()
            this.submitted = false
            this.$ma.trackEvent({
              event: 'Register',
              value: {
                Events_UserAccountNew: '1',
                Events_UserEmailSub: 'true',
                User_LoginType: 'Standard',
              },
            })
            this.handleClose()
          }
        })
      }
    },
    getDaysList() {
      return 31
    },
    getMonthsList() {
      return 12
    },
    getYearsList() {
      const d = new Date()
      const yearsList = []
      for (var k = 1900; k <= d.getFullYear(); k++) {
        yearsList.push(k)
      }
      return yearsList
    },
    labelFormatter(string) {
      if (string.substring(0, 1) === '*') {
        return string.substring(1, string.length)
      } else {
        return string
      }
    },
  },
}
